import Axios from "axios";

export default function (resource) {
    return {
        state: {
            single: null,
            name: resource,
            isFetchListPending: false,
            isFetchSinglePending: false,
            isSavePending: false,
            isDeletePending: false,
            isMovePending: false,
            list: [],
            errors: [],
            pagination: {
                current_page: 1,
                total: 1,
                last_page: 1,
                per_page: 50
            },
        },

        getters: {
            base_url(state, getters, rootGetters) {
                return rootGetters.config.app_url + state.base_url;
            }
        },

        actions: {
            getList({state, commit, getters, dispatch}, {
                page = 1,
                search = {},
                desc = false,
                sort_by = null,
                includes = [],
                fields = [],
                appends = [],
                pagination = 1,
                per_page = state.pagination.per_page,
            } = {}) {
                state.isFetchListPending = true;

                console.warn(per_page);

                return Axios.get(getters.base_url
                    + '?page=' + page
                    + '&per_page=' + per_page
                    + (Object.entries(search).length > 0 ? ('&' + Object.entries(search).map(filter => 'filter[' + filter[0] + ']=' + (Array.isArray(filter[1]) ? filter[1].join(',') : filter[1])).join('&')) : '')
                    + (sort_by !== null ? ('&sort=' + (desc ? '-' : '') + sort_by) : '')
                    + (includes.length > 0 ? ('&include=' + includes.join(',')) : '')
                    + (fields.length > 0 ? ('&fields[' + resource + ']=' + fields.join(',')) : '')
                    + (appends.length > 0 ? ('&append=' + appends.join(',')) : '')
                    + '&pagination=' + pagination
                    + '&translatable=1'
                )
                    .then(response => {
                        commit('SET_LIST', response.data.data);
                        commit('SET_PAGINATION', response.data.meta);
                    })
                    .catch(error => {
                        console.warn(error);
                        if (error.status === 404) {
                            dispatch('toasts/add', {type: 'error', message: 'Resource list not found'}, {root: true})
                        }
                        if(error.status === 400) {
                            dispatch('toasts/add', {type: 'error', message: error.data.message}, {root: true})
                        }
                    })
                    .finally(() => {
                        state.isFetchListPending = false;
                    });
            },
            getSingle({state, commit, getters, dispatch}, {id: id, includes = []}) {
                state.isFetchSinglePending = true;

                return Axios.get(getters.base_url + '/' + id + '?translatable=1' + (includes.length > 0 ? ('&include=' + includes.join(',')) : '') )
                    .then(response => {
                        commit('SET_SINGLE', response.data.data);
                    })
                    .catch(error => {
                        console.warn(error);
                        if (error.response && error.response.status === 404) {
                            dispatch('toasts/add', {type: 'error', message: 'Resource item not found'}, {root: true})
                        }
                    })
                    .finally(() => {
                        state.isFetchSinglePending = false;
                    });
            },
            store({state, getters, commit, dispatch}, {
                single = state.single,
                redirect = null,
                includes = []
            } = {single: state.single, includes: []}) {
                state.isSavePending = true;
                commit('SET_ERRORS', {});

                return Axios.post(getters.base_url + '?translatable=1' + (includes.length > 0 ? ('&include=' + includes.join(',')) : ''), single)
                    .then(response => {
                        commit('STORE_ITEM', response.data.data);
                        commit('SET_SINGLE', response.data.data);
                        if (redirect) { redirect() }
                        dispatch('modals/close', null, {root: true})
                        dispatch('toasts/add', {type: 'success', message: state.resourceName ? (state.resourceName + ' crée') : 'Resource Saved'}, {root: true})
                    })
                    .catch(error => {
                        console.warn(error);
                        if (error.status === 422) {
                            commit('SET_ERRORS', error.data.errors);
                        }
                    })
                    .finally(() => {
                        state.isSavePending = false;
                    })
            },
            update({state, getters, commit, dispatch}, {
                single = state.single,
                redirect = null,
                includes: includes = [],
                closeModal = true
            } = {single: state.single, includes: []}) {
                state.isSavePending = true;
                commit('SET_ERRORS', {});

                return Axios.put(`${ getters.base_url }/${ single.id }?translatable=1${ (includes.length > 0 ? ('&include=' + includes.join(',')) : '') }`, single)
                    .then(response => {
                        commit('UPDATE_ITEM', response.data.data);
                        commit('SET_SINGLE', response.data.data);
                        if (redirect) { redirect() }
                        if( closeModal ) { dispatch('modals/close', null, {root: true}) }
                        dispatch('toasts/add', {type: 'success', message: state.resourceName ? (state.resourceName + ' modifié') : 'Resource Saved' }, {root: true})
                    })
                    .catch(error => {
                        console.warn(error);
                        if (error.status === 422) {
                            commit('SET_ERRORS', error.data.errors);
                        }
                    })
                    .finally(() => {
                        state.isSavePending = false;
                    })
            },
            move({state, getters, commit, dispatch, rootGetters}, {movedFields = [], redirect = null}) {
                state.isMovePending = true;

                return Axios.post(`/api/sort/${state.name}`, {ids: movedFields.map(field => field.id)})
                    .then( (response) => {
                        if(response.data.status === 'error') {
                            dispatch('toasts/add', {type: 'error', message: "Resource can't be moved"}, {root: true})
                        }else {
                            dispatch('toasts/add', {type: 'success', message: 'Resource moved'}, {root: true})
                        }
                    })
                    .catch(error => {
                        console.warn(error);
                        if (error.response && error.response.status === 422) {
                            commit('SET_ERRORS', error.response.data.errors);
                        }
                    })
                    .finally(() => {
                        state.isMovePending = false;
                    })
            },
            delete({state, getters, commit, dispatch}, {
                id = state.single.id,
                redirect = null
            } = {id: state.single.id}) {
                state.isDeletePending = true;

                return Axios.delete(getters.base_url + '/' + id)
                    .then( () => {
                        commit('DELETE_ITEM', id);
                        commit('SET_SINGLE', state.model);
                        if (redirect) {
                            redirect()
                        }
                        dispatch('modals/close', null, {root: true})
                        dispatch('toasts/add', {type: 'success', message: state.resourceName ? (state.resourceName + ' supprimé') : 'Resource deleted'}, {root: true})
                    })
                    .catch(error => {
                        console.warn(error);
                    })
                    .finally(() => {
                        state.isDeletePending = false;
                    })
            },
            resetSingle({commit, state}) {
                commit('SET_SINGLE', state.model);
            },
            setSingle({commit}, item) {
                commit('SET_SINGLE', item);
            },
        },

        mutations: {
            SET_LIST(state, list) {
                state.list = list;
            },
            SET_SINGLE(state, item) {
                if(item) {
                    state.single = Object.assign({}, JSON.parse(JSON.stringify(item)));
                }
            },
            UPDATE_ITEM(state, item) {
                if (state.list.findIndex(element => element.id === item.id) !== -1) {
                    Object.assign(state.list[state.list.findIndex(element => element.id === item.id)], JSON.parse(JSON.stringify(item)));
                }
            },
            STORE_ITEM(state, item) {
                state.list.push({...state.model, ...item});
            },
            DELETE_ITEM(state, item_id) {
                if (state.list.findIndex(item => item.id === item_id) !== -1) {
                    state.list.splice(state.list.findIndex(item => item.id === item_id), 1);
                }
            },
            SET_ERRORS(state, errors) {
                state.errors = errors;
            },
            SET_PAGINATION(state, meta) {
                if(meta) {
                    state.pagination.current_page = meta.current_page;
                    state.pagination.total = meta.total;
                    state.pagination.last_page = Number(meta.last_page);
                }
            },
        },
    };
}


